import View from './view.js';
import React from 'react';

export default function Logic(props) {
  return (
    <View
      {...props}
      isSelected={props.isSelected || (props.id && props.id === props.selected)}
      onClick={() => props.onClick(props.id)}
    />
  );
}
